import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

export const createMarketAnalysisPost = async (payload) => {
  const response = await axiosClient.post('/api/admin/market-analysis-posts', payload);
  return unwrapApiResponse(response);
};

export const setFeaturedMarketAnalysisPost = async (pageId) => {
  const response = await axiosClient.put(`/api/admin/market-analysis-posts/${pageId}/featured`);
  return unwrapApiResponse(response);
};
